export default { sha: '696a299f78339c3d60e7f057e54cff004ee1bf9c', buildNumber: 'undefined' }
